import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 初始化时从 localStorage 获取用户信息
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || {
      id: null,
      account: "",
      name: "",
      age: "",
      sex: "",
      iden: "",
      token: "",
    },
    // userInfo: {
    //   id: null,
    //   account: "",
    //   name: "",
    //   token: "",
    // },
  },
  mutations: {
    // 接收数据并保存
    setUser(state, userInfo) {
      state.userInfo = userInfo;
      // 将用户信息保存到 localStorage
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    // 删除数据
    clearUser(state) {
      state.userInfo = {
        id: null,
        account: "",
        name: "",
        age: "",
        sex: "",
        iden: "",
        token: "",
      };
      // 清除 localStorage 中的用户信息
      localStorage.removeItem('userInfo');
    },
  },
  actions: {
  },
  getters: {
    // 导出state中存储的状态
    userInfo: state => state.userInfo
  },
  modules: {

  }
});

